import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "zadostiStavPopis",
  kodKey: "popis",
  placeholderText: "POTVRZENÝ"
});
